import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { GetReportRequest, QueryDefaults } from '../../../api';
import {
  reportDataState,
  reportPageNumberState,
  reportPaginationState,
  reportRequestState,
} from '../../../store';
import { ReportResponse } from '../../../types';

export const useBaseReport = (
  apiQueryKey: string,
  reportMethod: (request: GetReportRequest) => Promise<ReportResponse>
): UseQueryResult<ReportResponse> => {
  const request = useRecoilValue(reportRequestState);
  const setPageNumber = useSetRecoilState(reportPageNumberState);
  const setReportData = useSetRecoilState(reportDataState);
  const setReportPagination = useSetRecoilState(reportPaginationState);
  return useQuery([apiQueryKey, request], () => reportMethod(request), {
    ...QueryDefaults,
    onSuccess: (data: ReportResponse) => {
      if (data?.paginationInfo?.totalCount > 0 && data?.pagedResults.items.length === 0) {
        setPageNumber(1);
      }
      setReportData(data.pagedResults.items);
      setReportPagination(data.paginationInfo);
    },
  });
};
